(() => {
  // Keep menu dismissal independent of the product quantity controls.
  document.querySelectorAll('.eg-parity__menu').forEach(menu => {
    if (menu.dataset.egMenuReady) return;
    menu.dataset.egMenuReady = 'true';
    const summary = menu.querySelector(':scope > summary');
    const closeMenu = restoreFocus => {
      menu.open = false;
      if (restoreFocus) summary?.focus({ preventScroll: true });
    };
    menu.querySelector('[data-eg-menu-close]')?.addEventListener('click', () => closeMenu(true));
    document.addEventListener('pointerdown', event => {
      if (menu.open && !menu.contains(event.target)) closeMenu(false);
    }, true);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open && !event.defaultPrevented) {
        event.preventDefault();
        closeMenu(true);
      }
    });
  });

  document.querySelectorAll('[data-eg-batch]').forEach(root => {
    if (root.dataset.parityReady) return;
    const input = root.querySelector('input[name="quantity"][type="number"]');
    if (!input) return;
    root.dataset.parityReady = 'true';
    root.querySelectorAll('[data-eg-quantity-step]').forEach(button => button.addEventListener('click', () => {
      const current = Number(input.value) || 1;
      input.value = String(Math.max(1, current + Number(button.dataset.egQuantityStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    input.addEventListener('change', () => {
      if (!Number.isInteger(Number(input.value)) || Number(input.value) < 1) input.value = '1';
    });
    const form = root.querySelector('form');
    const sizeIndex = Number(root.dataset.sizeIndex ?? -1);
    const singleSizeLabel = (root.dataset.singleSizeLabel || '').trim();
    const sizeOption = sizeIndex >= 0 ? root.querySelector(`[data-eg-option="${sizeIndex}"]`) : null;
    root.querySelectorAll('[data-eg-inline-size-guide]').forEach(guide => {
      const summary = guide.querySelector('[data-eg-size-summary]');
      const groups = new Map();
      let activeGroup = '';
      guide.querySelectorAll('tbody tr').forEach(row => {
        const cells = [...row.cells];
        if (!cells.length) return;
        let usCell = cells[0];
        if (cells[0].tagName === 'TH') {
          activeGroup = cells[0].textContent.trim();
          usCell = cells[1];
        }
        if (!activeGroup || !usCell) return;
        if (!groups.has(activeGroup)) groups.set(activeGroup, []);
        const value = usCell.textContent.trim();
        if (value && !groups.get(activeGroup).includes(value)) groups.get(activeGroup).push(value);
      });
      const normalize = value => String(value || '').replace(/\s+/g, '').toLowerCase();
      const updateSizeSummary = variant => {
        const selectedSize = variant && sizeIndex >= 0 ? variant.options[sizeIndex] : sizeOption?.value || '';
        let entry = [...groups.entries()].find(([label]) => normalize(label) === normalize(selectedSize));
        const hasSingleChartGroup = groups.size === 1;
        if (!entry && hasSingleChartGroup) entry = [...groups.entries()][0];
        const isOneSize = hasSingleChartGroup && normalize(entry?.[0]).includes('onesize');
        const displaySize = isOneSize ? singleSizeLabel || 'One Size Fits Most' : selectedSize || entry?.[0];
        if (!entry || !entry[1].length) {
          summary.textContent = displaySize ? `${displaySize} · See exact original ranges` : 'See exact original ranges';
          return;
        }
        const values = entry[1];
        const range = values.length === 1 ? values[0] : `${values[0]}–${values[values.length - 1]}`;
        summary.textContent = `${displaySize || entry[0]} · US ${range}`;
      };
      updateSizeSummary();
      form?.addEventListener('variant:change', event => updateSizeSummary(event.detail?.variant));
    });
    root.querySelectorAll('.eg-parity__native-media details').forEach(details => {
      const frames = [...details.querySelectorAll('iframe')].map(frame => ({ frame, src: frame.getAttribute('src') }));
      frames.forEach(({ frame }) => frame.removeAttribute('src'));
      details.addEventListener('toggle', () => {
        frames.forEach(({ frame, src }) => {
          if (details.open && src) frame.setAttribute('src', src);
          else frame.removeAttribute('src');
        });
        if (!details.open) details.querySelectorAll('video').forEach(video => video.pause());
      });
    });
    root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => {
      dialog.querySelectorAll('video').forEach(video => video.pause());
      dialog.querySelectorAll('.eg-parity__native-media iframe').forEach(frame => frame.removeAttribute('src'));
      dialog.querySelectorAll('.eg-parity__native-media details').forEach(details => { details.open = false; });
    }));
  });
})();

